import { render, staticRenderFns } from "./ResponsibleUser.vue?vue&type=template&id=6f2d409a&scoped=true&"
import script from "./ResponsibleUser.vue?vue&type=script&lang=js&"
export * from "./ResponsibleUser.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleUser.vue?vue&type=style&index=0&id=6f2d409a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d409a",
  null
  
)

export default component.exports